// src/hooks/useClickOutside.ts
import { useEffect, RefObject } from "react";

// Make the hook generic to accept any HTMLElement type
export function useClickOutside<T extends HTMLDivElement | null>(
  ref: RefObject<T>,
  isActive: boolean,
  onClickOutside: () => void,
  resetSelection?: () => void,
  keepSelectionOnNavigation?: boolean,
): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        const isNavigationElement = (event.target as HTMLElement).closest(
          '[data-navigation="true"]',
        );

        if (!isNavigationElement || !keepSelectionOnNavigation) {
          onClickOutside();

          if (resetSelection) {
            resetSelection();
          }
        }
      }
    };

    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    ref,
    isActive,
    onClickOutside,
    resetSelection,
    keepSelectionOnNavigation,
  ]);
}
